import { render, staticRenderFns } from "./MatchRule.vue?vue&type=template&id=1b4bc6cc&scoped=true"
import script from "./MatchRule.vue?vue&type=script&lang=js"
export * from "./MatchRule.vue?vue&type=script&lang=js"
import style0 from "./MatchRule.vue?vue&type=style&index=0&id=1b4bc6cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b4bc6cc",
  null
  
)

export default component.exports